import React from 'react';
import { Card as MaterialCard, CardProps as MaterialCardProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '100%',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    }
  },
  spaced: {
    marginTop: theme.spacing(3)
  }
}))

interface CardProps extends MaterialCardProps {
  data?: any
  spaced?: boolean
  currentData?: any
  errorsConditions?: any
  saveFunction?: () => void
}

const Card = ({ ...props }: CardProps) => {
  const classes = useStyles()

  let cardClass = ''
  if (props.spaced === true) cardClass = classes.spaced

  return (
    <MaterialCard className={clsx(classes.root, cardClass, props.className)} >
      {props.children}
    </MaterialCard>
  )
}

export default Card
